// @flow
import { all, fork, put, takeLatest, call } from 'redux-saga/effects';

import { getAllUsersAdmin as getAllUsersApi } from '../../helpers/';

import { usersApiResponseSuccess, usersApiResponseError } from './actions';
import { UsersActionTypes } from './constants';
import { userResponseToUserObject } from '../../helpers/mappers/users';
import { addToast } from '../actions';
import { paginationHeadersResponse } from '../../helpers/mappers/pagination';

function* getAllUsers({ payload: { query } }) {
    try {
        const getAllUsersResponse = yield call(getAllUsersApi, query);
        const users = getAllUsersResponse.data.map((userResponse) => userResponseToUserObject(userResponse));
        const pagination = { ...paginationHeadersResponse(getAllUsersResponse.headers) };
        yield put(usersApiResponseSuccess(UsersActionTypes.GET_ALL_USERS, { users, pagination }));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(usersApiResponseError(UsersActionTypes.GET_ALL_USERS, error));
    }
}

export function* watchGetAllUsers(): any {
    yield takeLatest(UsersActionTypes.GET_ALL_USERS, getAllUsers);
}

function* usersSaga(): any {
    yield all([fork(watchGetAllUsers)]);
}

export default usersSaga;
